class LightboxGallery {
    constructor() {
        this.swiper = null;
        this.body = document.body;
        this.lightboxImages = document.querySelectorAll("[lightbox-toggle] img");
        this.lightboxImagesComments = document.querySelectorAll("[lightbox-toggleComments] img");
        this.initLightbox = this.lightboxImages.length > 0;
        this.initLightboxComments = this.lightboxImagesComments.length > 0;

        this.lightboxRef = null;
        this.swiperWrapperRef = null;

        if (this.initLightbox || this.initLightboxComments) {
            this.createLightboxSkeleton();
            this.initEventListeners();
        }
    }

    createLightboxSkeleton() {
        if (document.querySelector(".c-lightbox")) return; // Prevent duplicates

        // Create elements
        const lightbox = document.createElement("div");
        lightbox.classList.add("c-lightbox");
        lightbox.innerHTML = `
        <div class="c-lightbox__container">
          <div class="c-lightbox__close" tabindex="0">x</div>
          <div class="swiper-container">
            <div class="swiper-wrapper"></div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      `;

        this.body.appendChild(lightbox);
        this.lightboxRef = document.querySelector(".c-lightbox");
        this.swiperWrapperRef = document.querySelector(".c-lightbox .swiper-wrapper");
    }

    initEventListeners() {
        if (this.initLightbox) {
            this.lightboxImages.forEach((el, index) => el.addEventListener("click", () => this.openLightbox(index, this.lightboxImages)));
        }

        if (this.initLightboxComments) {
            this.lightboxImagesComments.forEach((el, index) => el.addEventListener("click", () => this.openLightbox(index, this.lightboxImagesComments)));
        }

        document.addEventListener("click", (event) => {
            if (event.target.matches(".c-lightbox__close")) {
                this.closeLightbox();
            }
        });

        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
                this.closeLightbox();
            }
        });
    }

    openLightbox(initialIndex, images) {
        this.swiperWrapperRef.innerHTML = '';
    
        images.forEach((img) => {
            const slide = document.createElement('div');
            slide.classList.add('swiper-slide');
    
            const imageContainer = document.createElement('div');
            imageContainer.classList.add('c-lightbox__image', 'swiper-zoom-container');
    
            const imageClone = img.cloneNode(true);
            imageClone.setAttribute('draggable', 'false');
            imageContainer.appendChild(imageClone);
            slide.appendChild(imageContainer);
            this.swiperWrapperRef.appendChild(slide);
        });
    
        const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    
        this.swiper = new Swiper('.c-lightbox .swiper-container', {
            initialSlide: initialIndex,
            loop: true,
            slidesPerView: 1,
            speed: 750,
            spaceBetween: 16,
            pagination: { el: '.swiper-pagination', type: 'fraction' },
            keyboard: { enabled: true, onlyInViewport: true },
            mousewheel: {
                sensitivity: 1,
                forceToAxis: true,
                invert: false,
            },
            zoom: isMobileDevice ? { maxRatio: 3, minRatio: 1 } : false,
            allowTouchMove: true,
        });
    
        if (isMobileDevice) {
            this.swiper.on('zoomChange', (swiper, scale) => {
                swiper.allowTouchMove = scale === 1;
            });
        }
    
        if (!navigator.userAgent.match(/Macintosh/i) || !('ontouchend' in document)) {
            this.enableFullScreen();
        }
    
        this.lightboxRef.classList.add('open');
        this.body.classList.add('overflowHidden');
        this.body.style.overflow = 'hidden';
    }
    
    enableFullScreen() {
        if (this.lightboxRef.requestFullscreen) {
            this.lightboxRef.requestFullscreen();
        } else if (this.lightboxRef.mozRequestFullScreen) { // Firefox
            this.lightboxRef.mozRequestFullScreen();
        } else if (this.lightboxRef.webkitRequestFullscreen) { // Chrome, Safari, Edge
            this.lightboxRef.webkitRequestFullscreen();
        } else if (this.lightboxRef.msRequestFullscreen) { // IE/Edge
            this.lightboxRef.msRequestFullscreen();
        }
    }

    closeLightbox() {
        if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement) {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.webkitExitFullscreen) { // Chrome, Safari
                document.webkitExitFullscreen();
            } else if (document.mozCancelFullScreen) { // Firefox
                document.mozCancelFullScreen();
            }
        }

        if (this.swiper) {
            setTimeout(() => {
                this.swiper.destroy();
                this.swiper = null;
            }, 250);
        }

        this.lightboxRef.classList.remove("open");
        this.body.classList.remove("overflowHidden");

        this.body.style.overflow = '';
    }

    destroy() {
        document.querySelectorAll("[lightbox-toggle] img").forEach((el) => el.removeEventListener("click", this.openLightbox));
        document.querySelectorAll("[lightbox-toggleComments] img").forEach((el) => el.removeEventListener("click", this.openLightbox));
        document.removeEventListener("click", this.closeLightbox);
        document.removeEventListener("keydown", this.closeLightbox);

        if (this.lightboxRef) {
            this.lightboxRef.remove();
            this.lightboxRef = null;
        }
    }
}

export default LightboxGallery;


// WEBPACK FOOTER //
// ./scripts/services/LightboxGallery.js